/**
 * Route: /campaigns/multi-goal — manage multiple named goals per campaign.
 *
 * Thin TanStack Router shell that renders the MultiGoalPage feature. The
 * page owns campaign picker, goal CRUD, and per-goal conversion listing.
 *
 * Theme: emerald -> sky gradient headline, zinc borders, 6-8px rounded,
 * light theme. No emojis, no competitor names.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { MultiGoalPage } from "../features/multi-goal/MultiGoalPage";

export const campaignsMultiGoalRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaigns/multi-goal",
	component: MultiGoalPage,
});

export default MultiGoalPage;
